import { AvatarObject } from '@/types';
import { storageDomain } from '@/utils/variables';
export const avatarAdapter = {
    mapAvatar(avatar: AvatarObject): AvatarObject {
        return {
            image: `https://${storageDomain}/avatars/${avatar.image}`,
            preview: `https://${storageDomain}/avatars/${avatar.preview}`
        };
    }
};
